import { render, staticRenderFns } from "./ChangeNameModal.vue?vue&type=template&id=d3b27e3e&"
import script from "./ChangeNameModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeNameModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports